import { BaseClient } from 'src/common-services/clients/base-client'

type OkResponse = {
  db: {
    ok: boolean
  }
  version: {
    version: string
    apiEnv: string
    nodeEnv: string
  }
}

export class OkClient extends BaseClient {
  getStatus(): Promise<OkResponse> {
    return this.call(`/ok`, 'GET')
  }
}
